module.exports = __webpack_public_path__ + "img/sent-base.d6ea5dd3.png";